module.exports = __webpack_public_path__ + "static/media/Notch.353265ba.svg";